const FAQS = [
  {
    q: '五姑娘影院需要注册才能观看吗？',
    a: '完全不需要注册！五姑娘影院坚持免费开放原则，所有电影资源均可直接在线观看，无需任何账号登录或个人信息填写。打开网站，选片即看，就是这么简单。',
  },
  {
    q: '影片的画质如何？支持高清播放吗？',
    a: '我们所有的影片均提供1080P全高清画质，部分热门影片更是支持4K超清画质。采用了先进的视频编码技术和CDN加速分发，确保画面清晰细腻的同时保持流畅不缓冲的播放体验。',
  },
  {
    q: '影片更新速度怎么样？最新上映的电影有吗？',
    a: '五姑娘影院团队每日保持50部以上的更新频率，紧跟全球影视热点。院线热映大片下映后通常48小时内即可在本站上线，经典高分电影更是一应俱全。点击首页"影音推荐"即可查看最新上架内容。',
  },
  {
    q: '支持哪些设备观看？可以在手机上观看吗？',
    a: '五姑娘影院完美适配电脑、平板、手机等所有主流设备。无论是在家中用大屏电脑沉浸观影，还是通勤路上用手机快速追剧，都可以获得一致的高清流畅体验。无需下载任何APP，浏览器打开即看。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-100 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            你关心的，我们都准备好了答案
          </p>
        </div>

        <div className="space-y-3">
          {FAQS.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-200/40 rounded-lg border border-background-300/30 p-5 md:p-6"
            >
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-100 mb-3 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {faq.q}
              </h3>
              <p className="text-sm md:text-base text-foreground-400 leading-relaxed pl-8">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}